export default __webpack_public_path__ + "static/media/Upload File (2).244b04a1.png";